import { render, staticRenderFns } from "./VPagination.vue?vue&type=template&id=19f62bc6&scoped=true"
import script from "./VPagination.vue?vue&type=script&lang=js"
export * from "./VPagination.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19f62bc6",
  null
  
)

export default component.exports